import { Col, Container, Row } from 'react-bootstrap';
import { CoachMiniCalendarBlock } from '../blocks/coach-mini-calendar';
import { AthleteMiniCalendarBlock } from '../blocks/athlete-mini-calendar';
import { CompetitionsBlock } from '../blocks/competitions';
import { useContext } from 'react';
import { UserContext } from '../../App';
import { t } from 'i18next';
import { AthletesMini } from '../blocks/athletes-mini';
import { TeamsMini } from '../blocks/teams-mini';
import { CompetitionsCalendarBlock } from '../blocks/competitions-calendar';
import { RankingsMini } from '../blocks/rankings-mini';
import { StatisticsMini } from '../blocks/statistics-mini';
import { AthletePerformanceBlock } from '../blocks/athlete-performance';
import { AthletesTeamsMini } from '../blocks/athletes-teams-mini';
import { EventsBlock } from '../blocks/events';

export default function Dashboard() {
    const { userProfile } = useContext(UserContext);

    return (
        <div className="dashboard-container">
            <Container>
                <Row>
                    <Col xs={12}>
                        <h1>
                            <span className="normal">{ t("welcome") }</span> { userProfile.name }
                        </h1>
                    </Col>
                </Row>
                { userProfile.role.filter((r: any) => r.id == 'badminton_administrator').length > 0 &&
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <TeamsMini />
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <AthletesMini />
                            <RankingsMini />
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <CompetitionsCalendarBlock />
                            <EventsBlock />
                        </Col>
                    </Row>
                }
                { userProfile.role.filter((r: any) => r.id == 'badminton_manager').length > 0 &&
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <TeamsMini /> {/*<AthletesTeamsMini />*/}
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <AthletesMini />
                            <RankingsMini />
                        </Col>
                        <Col xs={12} lg={4}>
                            <CompetitionsCalendarBlock />
                            <EventsBlock />
                        </Col>
                    </Row>
                }
                { userProfile.role.filter((r: any) => r.id == 'badminton_coach').length > 0 &&
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <CoachMiniCalendarBlock />
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <TeamsMini />
                            <AthletesMini />
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <CompetitionsBlock />
                            <RankingsMini />
                        </Col>
                    </Row>
                }
                { userProfile.role.filter((r: any) => r.id == 'badminton_athlete').length > 0 &&
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <AthleteMiniCalendarBlock />
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <AthletePerformanceBlock athlete_id={ 7 } />
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <CompetitionsBlock />
                        </Col>
                    </Row>
                }
            </Container>
        </div>
    );
}
